export const environment = {
  production: false,
  appName: 'Servvis Support (Dev)',
  version: '1.0.0-dev',
  supportDomain: 'https://dev.support.servvis.com',
  firebase: {
    apiKey: "AIzaSyCq_xg6jge0ZR98zEwbu8YZDoi-rww65Vg",
    authDomain: "dev.servvis.com",
    projectId: "servvis-ae-dev-70c8b",
    storageBucket: "servvis-ae-dev-70c8b.appspot.com",
    messagingSenderId: "8246184843",
    appId: "1:8246184843:web:139f6a74f5f09412aa7d8e"
  },
};
